import { render, staticRenderFns } from "./TextProperties.vue?vue&type=template&id=2ee5fc71&"
import script from "./TextProperties.vue?vue&type=script&lang=js&"
export * from "./TextProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports